import React from 'react';

type Props = {
  param: {
    // eslint-disable-next-line no-unused-vars
    onClick: (e: boolean) => boolean;
  };
};

const Confirmacao: React.FC<Props> = ({ param }) => {
  const top = document.getElementById('top');
  const categorias = document.getElementById('categorias');

  React.useEffect(() => {
    if (top) top.style.zIndex = '90';
    if (categorias) categorias.style.zIndex = '90';

    return () => {
      if (top) top.style.zIndex = '999';
      if (categorias) categorias.style.zIndex = '999';
    };
  }, [categorias, top]);

  return (
    <div>
      <div className="sacola-menu-opcoes" onClick={() => param.onClick(true)}>
        Sim
      </div>
      <div className="sacola-menu-opcoes" onClick={() => param.onClick(false)}>
        Não
      </div>
    </div>
  );
};

export default Confirmacao;
